import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { Mapaton_Title } from '../../../../../utils/EN/Modals/SpotsModals';

const ModalMapaton = () => {
  return (
    <>
      <ModalVideo
        id="spot-mapaton"
        dataText={Mapaton_Title}
        videoSrc="https://player.vimeo.com/video/644025021?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_MAPATON"
      />
    </>
  );
};

export default ModalMapaton;
